// Filas de cobertura del paso "Resumen" del workspace, una función por
// metodología — espejo de renderCoverage() del prototipo (por rama `cur`),
// adaptado a los nombres de campo reales de cada modelo.
const pct = (num, den) => (den ? Math.round((num / den) * 100) : 100);

function actionCoverageRow(items, t, critFilter, statLabelKey) {
  const crit = items.filter(critFilter);
  const withAction = crit.filter((i) => i.action && i.action.trim());
  return {
    label: t(statLabelKey),
    pct: pct(withAction.length, crit.length),
    note: `${withAction.length}/${crit.length}`,
  };
}

export function buildCoverageIso14001(items, t) {
  const n = items.length || 1;
  const sig = items.filter((i) => i.significance === "Significativo");
  return [
    { label: t("risk_matrix_coverage_items_loaded"), pct: Math.min(100, items.length * 20), note: `${items.length}` },
    actionCoverageRow(items, t, (i) => i.level >= 15, "risk_matrix_coverage_critical_with_action"),
    { label: t("risk_matrix_coverage_significant_aspects"), pct: pct(sig.length, n), note: `${sig.length}/${items.length}` },
  ];
}

export function buildCoverageIfrs(items, t) {
  const fis = items.filter((i) => (i.nature || "").startsWith("Físico"));
  const okv = fis.filter((i) => i.vulnerablePercent != null && i.vulnerablePercent !== "");
  return [
    { label: t("risk_matrix_coverage_items_loaded"), pct: Math.min(100, items.length * 20), note: `${items.length}` },
    actionCoverageRow(items, t, (i) => i.level >= 15, "risk_matrix_coverage_critical_with_action"),
    { label: t("risk_matrix_coverage_physical_vuln"), pct: pct(okv.length, fis.length), note: `${okv.length}/${fis.length}` },
  ];
}

export function buildCoverageGri(items, t) {
  const n = items.length || 1;
  const mat = items.filter((i) => i.level >= 10);
  return [
    { label: t("risk_matrix_coverage_items_loaded"), pct: Math.min(100, items.length * 20), note: `${items.length}` },
    actionCoverageRow(items, t, (i) => i.level >= 15, "risk_matrix_coverage_critical_with_action"),
    { label: t("risk_matrix_coverage_material_threshold"), pct: pct(mat.length, n), note: `${mat.length}/${items.length}` },
  ];
}

export function buildCoverageIso14091(items, t) {
  const n = items.length || 1;
  const withChain = items.filter((i) => i.chain && i.chain.trim());
  return [
    { label: t("risk_matrix_coverage_items_loaded"), pct: Math.min(100, items.length * 20), note: `${items.length}` },
    actionCoverageRow(items, t, (i) => i.level >= 15, "risk_matrix_coverage_critical_with_action"),
    { label: t("risk_matrix_coverage_impact_chain"), pct: pct(withChain.length, n), note: `${withChain.length}/${items.length}` },
  ];
}

export function buildCoverageLeopold(items, t) {
  return [
    { label: t("risk_matrix_coverage_interactions_loaded"), pct: Math.min(100, items.length * 20), note: `${items.length}` },
    actionCoverageRow(items, t, (i) => (+i.importance || 0) >= 7, "risk_matrix_coverage_priority_with_action"),
  ];
}

export function buildCoverageConesa(items, t) {
  return [
    { label: t("risk_matrix_coverage_impacts_loaded"), pct: Math.min(100, items.length * 20), note: `${items.length}` },
    actionCoverageRow(items, t, (i) => (+i.importance || 0) > 50, "risk_matrix_coverage_severe_with_action"),
  ];
}
